import { Controller } from '@hotwired/stimulus'

// Module-level so remembered positions survive Turbo body swaps
const positions = new Map()

// Restores an overflow container's horizontal scroll position across Turbo
// visits. Keyed by the container's link hrefs, so pages sharing a nav share a
// position while a different section's nav starts fresh at 0.
export default class extends Controller {
  connect() {
    this.key = Array.from(this.element.querySelectorAll('a[href]'), (link) =>
      link.getAttribute('href')
    ).join(',')

    if (positions.has(this.key)) {
      this.element.scrollLeft = positions.get(this.key)
    } else {
      this.centerActiveLink()
    }
  }

  // Deep links arrive with no saved position; center the current page's link
  // so it isn't offscreen. Adjusts scrollLeft directly instead of
  // scrollIntoView, which could also scroll ancestors.
  centerActiveLink() {
    const active = this.element.querySelector('[aria-current="page"]')
    if (!active) return

    const delta = active.getBoundingClientRect().left - this.element.getBoundingClientRect().left
    this.element.scrollLeft += delta - (this.element.clientWidth - active.offsetWidth) / 2
  }

  save() {
    positions.set(this.key, this.element.scrollLeft)
  }
}
